<template>
    <div class="project-item-list">
        <div v-for="item in data" :key="item.id" class="project-list-context">
            <div class="project-list-context__inner" @click="handleClick(item)">
                <div class="title-icon">
                    <img src="../assets/icon/1-提示-截止时间-图标@2x.png">
                    <!-- kbStatus 1:未开标 2:开标中 3:截标 -->
                    <span :class="`status kai-biao-status${item.kbStatus}`">
                        {{
                            `${item.kbStatus === 1 ? "距离开标时间 " : ""}` + item.restTime
                        }}
                    </span>
                </div>
                <p>
                    {{ item.title }}
                </p>
                <div class="project-list-context__inner-sub">
                    <span> 项目编号: {{ item.code }}</span>
                </div>
                <div class="project-list-context__inner-type">
                    <span> 公开招标 </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            data: {
                type: Array,
                default: () => [],
            },
        },
        methods: {
            handleClick(item) {
                this.$emit('handleClick', item)
            },
        },
    }
</script>

<style>
</style>
